import { action, observable } from 'mobx';
import { useStaticRendering } from 'mobx-react';
import ApiCore from '../ApiCore';

const isServer = !process.browser;
useStaticRendering(isServer);

class BlogStore {
  @observable post = {};

  @observable posts = [];

  @observable pagination = [];

  @observable comments = [];

  @observable keyword = '';

  @observable tags = [];

  @action index(page, limit, categoryId, keyword = '', tags = '') {
    return new Promise(() => {
      ApiCore.get('/wp/v2/posts', {
        categories: categoryId, page, per_page: limit, search: keyword, tags,
      }).then((response) => {
        this.keyword = keyword;
        this.posts = response.data;

        this.pagination = {
          postCount: response.paging.total,
          pageCount: response.paging.totalPages,
        };
      });
    });
  }

  @action show = async slug => new Promise((resolve) => {
    ApiCore.get('/wp/v2/posts', { slug })
      .then((response) => {
        [this.post] = response.data;
      })
      .then(() => resolve());
  });

  /**
   * Returns a list of comments for a specific post
   * @param {string} postId The wordpress post id
   * @return {Promise}
   */
  @action getPostComments = async (postId) => {
    if (!postId) {
      return Promise.rejected();
    }

    return new Promise((resolveCommentList) => {
      ApiCore.get('/wp/v2/comments', { post: postId })
        .then((response) => {
          this.comments = response.data;
        })
        .then(() => resolveCommentList());
    });
  };

  /**
   * @param {string} postId The wordpress post id
   * @param {integer} authenticatedUserId The wordpress user id
   * @param {object} commentPayload Comment paylaod from the form
   * @return {Promise}
   */
  @action postNewComment = (postId, authenticatedUserId, commentPayload) => {
    if (!postId || !authenticatedUserId || !commentPayload) {
      return Promise.reject();
    }

    let params = {
      post: postId,
      author: authenticatedUserId,
      content: commentPayload.content,
      status: 'hold',
    };

    if (commentPayload.authorName && commentPayload.authorName.length > 0) {
      params = { ...params, author_name: commentPayload.authorName };
    }


    return ApiCore.post('/wp/v2/comments', params)
      .then(response => Promise.resolve(response));
  }

  @action getTags = (tags) => {
    ApiCore.get('/wp/v2/tags', { include: tags }).then(
      (response) => {
        this.tags = response.data;
      },
    );
  };

  @action clearPosts = () => {
    this.posts = [];
  };

  @action setKeyword = (keyword) => {
    this.keyword = keyword;
  };
}

let blogStore = null;

export default function initializeBlogStore(initialData) {
  if (isServer) {
    return new BlogStore(isServer, initialData);
  }

  if (blogStore === null) {
    blogStore = new BlogStore(isServer, initialData);
  }

  return blogStore;
}
